const RADIX = 36;
const RANDOM_SYMBOL_COUNT = 2;

export default function generateUid(): string {
    return (
        Math.random()
            .toString(RADIX)
            .substring(RANDOM_SYMBOL_COUNT) + Date.now().toString(RADIX)
    );
}
